import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import AccountActivityReportCtrl from '../../../components/reportsComponents/accountmanagement/accountActivityReportCtrl';
import AccountActivityReportTable from '../../../components/reportsComponents/accountmanagement/accountContactReportTable';
const pageTitle = 'Invoice Activity'
let AccountActivityReportForm={
	formAccountActivityReportInfo:{}
}

class AccountActivityReport extends Component {
	constructor() {
		super();
		this.state = {
            asOfDate:''
		}
	}
	componentWillMount = () => {
		document.title = pageTitle;
		
    }
    onAccountActivityFieldChange=(key, value)=>{
        this.setState({[key]:value});
    }
	render() {
		return (
            <Fragment>
                <div className="page-header">
                    <div className="row mb-10">
                        <div className="col-md-12 col-sm-12">
                            <div className="title">
                                <h4> Billable Invoice Activity</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="pd-10 bg-white border-radius-4 box-shadow">
                    <AccountActivityReportCtrl onAccountActivityFieldChange={(key, value)=>this.onAccountActivityFieldChange(key, value)}
                    initCallBack={(frm)=>{
						AccountActivityReportForm.formAccountActivityReportInfo=frm;
                    }} asofdate={this.state.asOfDate}/>
                    <AccountActivityReportTable />
                </div>
            </Fragment>
		);
	}
}
const mapStateToProps = (state, ownProps) => {
	return {
		
	}
};

export default withRouter(connect(mapStateToProps)(AccountActivityReport));
